import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  CIFValue: [],
};

const CIFValueSlice = createSlice({
  name: "CIFValue",
  initialState,
  reducers: {
    updateCIFValue: (state, action) => {
      const index = state.CIFValue.findIndex(
        (item) => item.country === action.payload.country
      );
      if (index !== -1) {
        state.CIFValue[index] = action.payload;
      } else {
        state.CIFValue.push(action.payload);
      }
    },
  },
});

export const { updateCIFValue } = CIFValueSlice.actions;

export default CIFValueSlice.reducer;
